//选择仓库
import * as React from 'react';
import { Alert, Shadow, Pagi } from '@/components';
import { Button, Table, Radio, Icon, Checkbox, Input } from 'uiw';
import API from '@/utils/http';
import style from '../index.module.scss';

export default class WareHouseMultiShadow extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            columns: [
                {
                    title: '',
                    width: 60,
                    key: 'checked',
                    render: (text: any, key: any, rowData: any, rowNumber: number, columnNumber: number) => (
                        <div className={style.radioShadow}>
                            <div className={style.bg}></div>
                            <Checkbox name='unit' checked={rowData.checked} ></Checkbox>
                        </div>
                    )
                },
                { title: '商城仓库编号', width: 200, key: 'storageNo' },
                {
                    title: '商城仓库名称',
                    key: 'storageName',
                    render: (text: any, key: any, rowData: any, rowNumber: number, columnNumber: number) => (
                        <p className="overflow">{rowData.storageName}</p>
                    )
                }
            ],
            dataSource: [],
            choosed: [],// 已选择数组
            page: {
                pageIndex: 1,
                pageSize: 10,
                count: 0
            },
            searchForm: {
                no: '',
                name: ''
            }
        }
    }

    checkItem(e: any, item: any) {

    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.isOpen == true) {
            // 处理历史数据，过滤掉含有TypeId的项
            let temp = nextProps.choosed.filter((obj: any) => !obj.TypeId);
            this.setState({
                choosed: temp,
            })
            this.getData(1);
        }
    }


    onClose = () => {
        this.props.onClose && this.props.onClose();
    }

    onConfirm = () => {
        let { choosed } = this.state;
        this.props.onConfirm && this.props.onConfirm(choosed);
    }

    getData = (n: number) => {
        let { searchForm } = this.state;
        let param = {
            mth: 'GetEcShopStorage',
            EcShopStorageNo: searchForm.no,
            EcShopStorageName: searchForm.name,
            pageCurrent: n
        }
        API.postData(param, '/UI/stock/ajax.ashx', (res: any) => {
            let obj: any = {};
            obj.pageIndex = n;
            obj.pageSize = res.pageSize;
            obj.count = res.rowCount;
            this.setState({
                dataSource: res.data,
                page: obj
            })
        })
    }

    //选择行
    chooseItem = (data: any) => {
        let that = this;
        let { choosed } = that.state;

        // 判断已选择数组中是否含有该值，有则排除，无则添加
        let existModel = choosed.find((obj: any) => obj.Id == data.storageID);
        if (existModel == null) {
            choosed.push({
                Id: data.storageID,
                No: data.storageNo,
                Name: data.storageName
            });
        } else {
            const index = choosed.findIndex((obj: any) => obj.Id == data.storageID);
            choosed.splice(index, 1);
        }
        that.setState({
            choosed
        })

    }

    //改变表单
    changeForm = (name: string, e: any) => {
        let obj = this.state.searchForm;
        obj[name] = e.target.value;
        this.setState({
            searchForm: obj
        })
    }

    render() {
        let { isOpen } = this.props;
        let { columns, dataSource, choosed, searchForm } = this.state;
        if (dataSource != null && dataSource.length > 0) {
            dataSource = dataSource.map((item: any, idx: number) => {
                const isChecked = choosed.find((obj: any) => obj.Id == item.storageID) != null;
                return { checked: isChecked, ...item };
            });
        }
        return (
            <Shadow
                title="选择商城仓库"
                isOpen={isOpen}
                height={400}
                width={800}
                onClose={this.onClose.bind(this)}
                footer={
                    <React.Fragment>
                        <Button type="primary" onClick={this.onConfirm.bind(this)}>选择</Button>
                    </React.Fragment>
                }
            >
                <div className="shadow-search box box-center">
                    <div className="box box-center">
                        <p>商城仓库编号</p>
                        <Input
                            placeholder="编号为精确匹配"
                            style={{ width: 200 }}
                            className="marleft"
                            defaultValue={searchForm.no}
                            onChange={this.changeForm.bind(this, 'no')}
                        />
                    </div>
                    <div className="box box-center marleft">
                        <p>商城仓库名称</p>
                        <Input
                            placeholder="名称可模糊查找"
                            style={{ width: 200 }}
                            className="marleft"
                            defaultValue={searchForm.name}
                            onChange={this.changeForm.bind(this, 'name')}
                        />
                    </div>
                    <Button type="primary" className="marleft" onClick={() => this.getData(1)}>查询</Button>
                </div>
                <Table
                    className="custom-table custom-table-hasline"
                    columns={columns}
                    data={dataSource}
                    onCell={(rowData) => {
                        this.chooseItem(rowData);
                    }}
                />
            </Shadow>
        )
    }
}